import React from 'react';
import { motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
import { SectionTag } from './SectionTag';
import { SYSTEM_PILLARS } from './salesData';
const NOT_THIS: string[] = ['Sin improvisar todos los días', 'Sin depender de publicar por publicar', 'Sin perder horas tratando de descubrir qué hacer'];
export function PositioningSection() {
  return <section className="bg-sand py-12 sm:py-16" data-id="element-210" data-mp="q6hcbfuaq7u1">
      <div className="mx-auto max-w-4xl px-5" data-id="element-211" data-mp="q7938dcy7hdz">
        <div className="text-center" data-id="element-212" data-mp="m4vxvq245lhq">
          <SectionTag data-id="element-213" data-mp="m3t85lgj1p3e">La solución</SectionTag>
          <h2 className="mt-4 font-display text-[1.55rem] font-bold uppercase leading-tight text-charcoal sm:text-[2.2rem]" data-id="element-214" data-mp="m78kigitgk14">
            No necesitás convertirte en experto en marketing.
            <span className="mt-1 block text-gold-deep" data-id="element-215" data-mp="c8svqk79hmus">Necesitás un sistema.</span>
          </h2>
          <p className="mx-auto mt-4 max-w-2xl font-sans text-sm leading-relaxed text-charcoal/70 sm:text-base" data-id="element-216" data-mp="2bhpvkuq107k4">
            Coach Digital PRO organiza en un solo sistema las herramientas que necesitás para
            posicionarte, comunicar tu valor, crear contenido estratégico y transformar seguidores
            en potenciales clientes.
          </p>
        </div>

        <ul className="mt-7 flex flex-wrap justify-center gap-2" data-id="element-217" data-mp="1vhnfswlr5ucu">
          {NOT_THIS.map(item => <li key={item} className="inline-flex items-center gap-1.5 rounded-full border border-stone bg-ivory px-3.5 py-1.5 font-sans text-[0.72rem] font-medium text-charcoal/70" data-id="element-218" data-mp="20fyr7brp4cx6">
              <XIcon className="h-3.5 w-3.5 shrink-0 text-charcoal/40" aria-hidden data-id="element-219" data-mp="2t66y27gs7awg" />
              {item}
            </li>)}
        </ul>

        <h3 className="mt-9 text-center font-display text-lg font-bold uppercase leading-tight text-charcoal sm:text-2xl" data-id="element-220" data-mp="2jdj3zkh6rl1f">
          Las 5 funciones que tu presencia digital necesita cumplir
        </h3>

        <div className="mt-5 grid gap-3 sm:grid-cols-2 lg:grid-cols-5" data-id="element-221" data-mp="3bvnek48v3dyi">
          {SYSTEM_PILLARS.map((pillar, i) => <motion.article key={pillar.title} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.35,
          delay: i * 0.05
        }} className="rounded-xl border border-stone bg-ivory p-4" data-id="element-222" data-mp="3lq2fy2ruhkrj" data-mpi={i}>
              <p className="font-sans text-[0.6rem] font-bold uppercase tracking-editorial text-gold-deep" data-id="element-223" data-mp="32s8bm21nvxfh">
                0{i + 1}
              </p>
              <h4 className="mt-1.5 font-display text-base font-bold leading-tight text-charcoal" data-id="element-224" data-mp="2xzosyqo4ac3t">
                {pillar.title}
              </h4>
              <p className="mt-1 font-sans text-[0.78rem] leading-snug text-charcoal/70" data-id="element-225" data-mp="2o3c0tx8806b6">
                {pillar.desc}
              </p>
            </motion.article>)}
        </div>
      </div>
    </section>;
}